import { gql } from "@apollo/client/core";

/**
 * Fetches the Level(s) (EU) lifetime source for the given country, plus the
 * `buildingPart` and `building_element` lookup tables used to resolve
 * `parent_id` and `buildingElementId` to labels.
 *
 * The Level(s) source has no classification code mappings — rows are grouped
 * by building_part.parent_id → building_part → building_element instead.
 *
 * NOTE: This query is hand-typed in `LevelsLifetimesTypes.ts` because the
 * Hasura schema currently lacks two object relationships that would make
 * label resolution declarative:
 *   - `building_part.parent` (self-referential)
 *   - `building_part_service_lifetime.buildingElement`
 * Until those are added on the backend (so `npm run codegen` can pick them
 * up), this query fetches the lookup tables in the same operation and the
 * UI joins on `id` client-side.
 */
const GetLevelsLifetimesQuery = gql`
  query GetLevelsLifetimes($sourceId: uuid!) @cached {
    buildingPartLifetimeSource(where: { id: { _eq: $sourceId } }) {
      id
      label
      source
      serviceLifetimes(order_by: { buildingPart: { label: asc } }) {
        id
        lifetimeAverage
        lifetimeLow
        lifetimeHigh
        buildingElementId
        buildingPart {
          id
          label
          parent_id
        }
      }
    }
    buildingPart {
      id
      label
    }
    building_element {
      id
      label
    }
  }
`;

export default GetLevelsLifetimesQuery;
